import styled from 'styled-components';

export default styled.time`
  display: block;
  padding: .5rem 0;
  color: ${({ theme }) => theme.grayColor};
  font-size: .75rem;
`;
